export default __webpack_public_path__ + "static/media/sn-help-number-it.3bd60102.jpg";